import React, { memo } from 'react';
import { Cell, Row, Select } from '@dexma/ui-components';
import { StyledSelectCell, StyledWidgetSelector } from 'adapter/in/common/components/Selector/style';

import gtmIds from 'adapter/in/dashboards/config/gtm';
import { SelectorOption, SelectorValueOptions } from 'adapter/in/common/form/types';
import { FooterInputText } from 'adapter/in/common/components/Text';

const mapValues = (values?: SelectorOption[]): string[] => (values ? values.map((value: SelectorOption) => value.value) : []);

export type WidgetSelectorType = {
    label: string;
    name: string;
    placeholder?: string;
    options: SelectorOption[] | undefined;
    value: SelectorValueOptions | undefined;
    isLoading: boolean;
    error: boolean;
    maxSelectionLength: number;
    minSelectionLength: number;
    onChange: (selectedValue: string | string[]) => void;
    onClear?: (onChangeCallback: (e: string | string[]) => void) => void;
    handleButtonSelectAll?: (values: string[]) => void;
    handleClearAll?: () => void;
    disabled?: boolean;
    errorMessage?: string;
    footer?: string;
    style?: React.CSSProperties;
};
const FormSelector = memo((props: WidgetSelectorType) => {
    const {
        label,
        onChange,
        onClear,
        handleButtonSelectAll,
        handleClearAll,
        disabled,
        options,
        placeholder,
        value,
        isLoading,
        error,
        errorMessage,
        maxSelectionLength,
        minSelectionLength,
        name,
        footer,
        style,
    } = props;
    const parsedValues = mapValues(value as SelectorOption[]);
    const isMultiple = maxSelectionLength > 1;
    const allowClear = minSelectionLength === 0 || isMultiple;
    return (
        <StyledWidgetSelector $error={!isLoading && error} style={style}>
            <Row>
                <Cell className='widget-type-block'>
                    <span>{label}</span>
                </Cell>
            </Row>
            <Row>
                <StyledSelectCell>
                    <Select
                        disabled={disabled}
                        className={`select_${name}`}
                        data-testid={name}
                        dataId={`${gtmIds.addWidget.sidePanel.form.select}.${name}`}
                        isLoading={isLoading}
                        placeholder={placeholder}
                        options={options}
                        onChange={onChange}
                        onClear={onClear as any}
                        mode={isMultiple ? 'multiple' : 'single'}
                        handleButtonSelectAll={handleButtonSelectAll}
                        handleClearAll={handleClearAll}
                        defaultValues={parsedValues}
                        value={parsedValues}
                        pageSize={maxSelectionLength}
                        allowClear={allowClear}
                    />
                    {!isLoading && error && <div className='error'>{errorMessage}</div>}
                </StyledSelectCell>
            </Row>
            {footer && <FooterInputText text={footer} />}
        </StyledWidgetSelector>
    );
});

export default FormSelector;
